module.exports = __webpack_public_path__ + "static/media/mobile-step1-en.9f6f22e4.png";